export default __webpack_public_path__ + "static/media/eye-close.7c208e0c.svg";